import { FC, useEffect, useState } from 'react';

import { Box } from '@material-ui/core';

import EventNotification from 'common/services/event-notification';
import { DepositStatus, postAction } from 'deposit/services/types';

import { translate } from 'common/config/i18n';
import { useAppSelector, useParentPostMessage } from 'common/helpers/hooks';
import { redirectWithScheme } from 'common/helpers/url';
import { getDepositInfo } from 'common/store/deposit';

const TimerToRedirect: FC<{
  url?: string;
  message?: { status: DepositStatus | undefined; depositExternalId: string };
  merchantName: string;
  time?: number;
  callback?: () => void;
}> = ({ merchantName, message, url, callback, time = 8 }) => {
  const [timeLeft, setTimeLeft] = useState(time);
  const depositInfo = useAppSelector(getDepositInfo);
  const postActionRedirect = depositInfo && depositInfo.postAction === postAction.REDIRECT;
  const eventNotification = new EventNotification('*', window);

  useEffect(() => {
    if (!url) {
      return;
    }
    if (timeLeft === -1) {
      eventNotification.notify('close', {});
      useParentPostMessage(
        parent,
        { action: 'close', message },
        true,
        undefined,
        postActionRedirect,
      );
      callback && callback();
      redirectWithScheme(url);
      return;
    }

    const interval = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearTimeout(interval);
  }, [timeLeft, url]);

  if (!url) {
    return null;
  }

  return (
    <Box textAlign="center">
      {translate('one_touch_redirect_to_merchant', {
        merchantName,
        timeLeft: timeLeft < 0 ? 0 : timeLeft,
      })}
    </Box>
  );
};

export default TimerToRedirect;
